const selectedSharedQueries = (context) => context.selectedSharedQueries;

const sharedQueriesAllSelected = (context) => context.sharedQueriesAllSelected;

const getSelectedSharedQueriesIds = (context) => {
  const Ids = [];
  context.selectedSharedQueries.forEach((sharedQuery) => {
    Ids.push(sharedQuery.id);
  });
  return Ids;
};

export default {
  selectedSharedQueries,
  sharedQueriesAllSelected,
  getSelectedSharedQueriesIds,
};
